import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=7dacafc8&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=7dacafc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dacafc8",
  null
  
)

export default component.exports